import { render, staticRenderFns } from "./premiumBarDesign.vue?vue&type=template&id=72cb808b&scoped=true"
import script from "./premiumBarDesign.vue?vue&type=script&scoped=true&lang=js"
export * from "./premiumBarDesign.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./premiumBarDesign.vue?vue&type=style&index=0&id=72cb808b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cb808b",
  null
  
)

export default component.exports